import React from "react";

function Footer() {
  return (
    <footer className="main_footer">
      {/* Footer Top */}
      <div className="footer_top">
        <div className="container">
          <div className="row">
            {/* About Widget */}
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <div className="footer_widget about_widget">
                <figure className="footer_logo">
                  <a href="/">
                    <img src="/images/footer-logo.png" alt="Footer Logo" />
                  </a>
                </figure>
                <p>
                  Empowering finance with innovation, security and global reach.
                </p>
                <ul className="social-links">
                  <li>
                    <a href="#">
                      <i class="fa-brands fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa-brands fa-square-x-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa-brands fa-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Pages Widget */}
            <div className="col-xl-2 col-lg-4 col-md-6 col-sm-12">
              <div className="footer_widget page_widget">
                <h4 className="footer_widget_title">Pages</h4>
                <ul className="page_list">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="/about">About us</a>
                  </li>
                  <li>
                    <a href="/contact">Contact</a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Primary Pages Widget */}
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
              <div className="footer_widget primary_page_widget">
                <h4 className="footer_widget_title">Policy Pages</h4>
                <ul className="primary_page_list">
                  {/* <li>
                    <a href="/blog">Blog</a>
                  </li>
                  <li>
                    <a href="/faq">FAQ</a>
                  </li>
                  <li>
                    <a href="/privacy-policy">Privacy Policy</a>
                  </li> */}
                  <li>
                    <a href="/terms-and-conditions">Terms And Conditions</a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Widget */}
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
              <div className="footer_widget newsletter_widget">
                <h4 className="footer_widget_title">Contact</h4>
                <ul className="primary_page_list">
                  <li>
                    <a href="mailto:support@ecomantracap.com">
                      <i className="fa-solid fa-envelope"></i>{" "}
                      support@ecomantracap.com
                    </a>
                  </li>
                  <li>
                    <a href="tel:+919876543210">
                      <i className="fa-solid fa-phone"></i> +91 98765 43210
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa-solid fa-location-dot"></i> Mumbai,
                      Maharashtra, India
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer_bottom">
        <div className="container">
          <div className="copyright">
            © 2026 Eco Mantra Capital | Design By{" "}
            <a
              href="https://graspcorn.com/"
              target="_blank"
              rel="noreferrer"
              style={{ margin: "0 8px" }}
            >
              Graspcorn
            </a>
            All Rights Reserved
          </div>
        </div>
      </div>

      <div className="footer_shape"></div>
    </footer>
  );
}

export default Footer;
